import { QueryClient } from '@tanstack/react-query';
export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 30_000,
            gcTime: 5 * 60_000,
            refetchOnWindowFocus: false,
            retry: (failureCount, err) => {
                if (err && typeof err === 'object' && 'status' in err) {
                    const s = err.status;
                    if (s === 401 || s === 403 || s === 404)
                        return false;
                }
                return failureCount < 1;
            },
        },
    },
});
